module.exports = __webpack_public_path__ + "static/assets/0611d215fe34175ddbab01f4f48f3517.jpg";